document.addEventListener("DOMContentLoaded", () => {
  const /** @type HTMLFormElement */ attribute_form = document.getElementById("attribute_form");
  if(!attribute_form) {
    return;
  }
  const attribute_form_clear = document.getElementById("attribute_form_clear");

  // tum filtreleri temizle butonu
  if (attribute_form_clear) {
    attribute_form_clear.addEventListener("click", () => {
      attribute_form.querySelectorAll("input").forEach((input) => {
        if("checkbox" === input.type) {
          input.checked = false;
        }
      });
      attribute_form.submit();
    });
  }

  // filtre temizle butonları
  document.querySelectorAll("[data-attribute-clear-id]").forEach((/** @type HTMLButtonElement */ button) => {
    button.addEventListener("click", () => {
      const checkbox = attribute_form.querySelector("input[type=\"checkbox\"]#" + button.dataset.attributeClearId);
      if (!checkbox) {
        return;
      }
      checkbox.checked = false;
      attribute_form.submit();
    });
  });
});